// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2EUQx","field":"styles_field__3x2bg","fieldCol":"styles_fieldCol__2Obwx","diffCol":"styles_diffCol__3LRAv","diff":"styles_diff__2UR4r"};